export default __webpack_public_path__ + "static/media/polaroid-spectrum.19a8765d.png";